import * as React from 'react';

import { Modal, Button, EButtonSize, EButtonStyle } from '@my/myworld-ui-kit';

import { HtmlEntities } from '@utils';

import { Icon } from '@base/components';
import { getTranslation } from '@base/utils';

import { InfoOutline16 } from '@icons';

import { IMainMenuContentInfoProps } from './types';

import * as s from './MainMenuContentInfo.scss';

export const MainMenuContentInfo = (props: IMainMenuContentInfoProps) => {
	const { contentHtml } = props;
	const t = getTranslation('components.MainMenu.MainMenuContentInfo');
	const [shouldShowModal, setShouldShowModal] = React.useState(false);

	const handleOpenModal = () =>
		setShouldShowModal(true);

	const handleCloseModal = () =>
		setShouldShowModal(false);

	const footerButtons = [
		<Button
			key="close-btn"
			className={s.closeBtn}
			size={EButtonSize.M}
			style={EButtonStyle.PRIMARY_ACCENT}
			label={t('modalClose')}
			onClick={handleCloseModal}
		/>,
	];

	return <>
		<span
			className={s.link}
			onClick={handleOpenModal}
		>
			{t('linkText')}
			<Icon
				className={s.linkIcon}
				glyph={InfoOutline16}
			/>
		</span>

		<Modal
			isVisible={shouldShowModal}
			header={t('modalTitle')}
			footer={footerButtons}
			onClose={handleCloseModal}
		>
			<div
				className={s.content}
				dangerouslySetInnerHTML={{
					__html: HtmlEntities.decode(contentHtml),
				}}
			/>
		</Modal>
	</>;
};
